import React from 'react';

export const useNumber = () => {
  const formatCurrency = React.useCallback(
    value =>
      Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(!value ? 0 : value / 100),
    [],
  );

  return { formatCurrency };
};

export default useNumber;
